export class SubStatus {
  subStatusId
  status

  constructor(subStatus = {}) {
    this.subStatusId = subStatus.subStatusId ? String(subStatus.subStatusId) : ''
    this.status = subStatus.status ? String(subStatus.status) : ''
  }
}